
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import Icon from '../../../icons'
import $ from 'jquery'
export default{
components: {
XDialog,
Icon,
Spinner
},
data() {
return {
maskTransition: 'vux-mask',
dialogTransition: 'vux-dialog',
show: false,
noticeInfo: Object,
loadingFinish: false
}
},
methods: {
sureBtnClick() {
this.dismiss();
},
closeBtnClick() {
this.dismiss();
},
dismiss() {
this.show = false;
},
fixScrollBug(scrollNode, parentNode) {
let startX;
let startY;

scrollNode.bind('touchstart', function (events) {
startX = events.originalEvent.changedTouches[0].pageX;
startY = events.originalEvent.changedTouches[0].pageY;
});
scrollNode.bind('touchmove', function (e) {
let ulheight = $(this).height();
let scrollTop = $(this).scrollTop();
let scrollheight = $(this)[0].scrollHeight;
if (ulheight + scrollTop + 20 >= scrollheight) { // 滚到底部20px左右
parentNode.bind('touchmove', function (event) {
let moveEndY = event.originalEvent.changedTouches[0].pageY;
let theY = moveEndY - startY;
let moveEndX = event.originalEvent.changedTouches[0].pageX;
let theX = moveEndX - startX;
if (Math.abs(theY) > Math.abs(theX) && theY > 0) { // 用上面的abs()更加准确！这里是判断上滑还是下滑！可以用角度函数也可以用上面绝对值方式！
parentNode.unbind('touchmove'); 
}
if (Math.abs(theY) > Math.abs(theX) && theY < 0) {
event.preventDefault(); 
}
})
}
if (scrollTop < 20) { // 滚到顶部20px左右
parentNode.bind('touchmove', function (event) {
let moveEndY = event.originalEvent.changedTouches[0].pageY;
let theY = moveEndY - startY;
let moveEndX = event.originalEvent.changedTouches[0].pageX;
let theX = moveEndX - startX;
if (Math.abs(theY) > Math.abs(theX) && theY > 0) {
event.preventDefault();
}
if (Math.abs(theY) > Math.abs(theX) && theY < 0) {
parentNode.unbind('touchmove');
}
})
}
});
},
updateLoadingState() {
let that = this;

window.setTimeout(function () {
$('#notice-view-iframe').attr('src', that.noticeInfo.url);
}, 500);
let iframe = document.getElementById('notice-view-iframe');
iframe.addEventListener('load', function () {
that.loadingFinish = true;
this.removeEventListener('load', arguments.call, false);
})
}
},
watch: {
show: function (newVal, oldVle) {
if (newVal) {
if (this.noticeInfo.type === '3') {
$('.middle-content').empty();
$('.middle-content').append(this.noticeInfo.noticeText);
} else {
this.loadingFinish = false;
}
this.updateLoadingState();
}
}
},
mounted() {
if (this.noticeInfo.type === '3') {
$('.middle-content').empty();
$('.middle-content').append(this.noticeInfo.noticeText);
}
this.$nextTick(function () {
this.fixScrollBug($('.middle-content'), $('.alert-notice-container'));
this.fixScrollBug($('#notice-view-iframe'), $('.middle-content-iframe'));
this.updateLoadingState();
})
}
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-notice-view.vue